import Modal from './modal';

/** Uses the Modal class in modal.js to preent a simple alert box */
export default function idmAlert(text) {
  // Create a modal with the text passed and a single "OK" button
  const modal = new Modal();
  modal.show('', text, '<button type="button" class="btn btn-primary" data-bs-dismiss="modal">OK</button>');
}
